export enum ClientType {
  Lite = 1,
  Solteiro = 2,
  STP = 3,
}
